module.exports = __webpack_public_path__ + "static/media/game-play-menu.6b7f1b57.svg";